import { render } from "./Sconto.vue?vue&type=template&id=5e8874bc"
import script from "./Sconto.vue?vue&type=script&lang=js"
export * from "./Sconto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__